import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions.js';
import Pipeline from './Pipeline.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_pipeline_index',
    component: Pipeline,
    meta: {
      featureFlag: FEATURE_FLAGS.CRM,
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
